import { useState } from "react";
import { Copy } from "lucide-react";
import CandidateTable from "../components/creator/CandidateTable";
import AssessmentSetup from "../components/creator/AssessmentSetup";
import OnboardingScriptEditor from "../components/creator/OnboardingScriptEditor";
import CreatorAgreementsAdmin from "../components/creator/CreatorAgreementsAdmin";

const TABS = [["candidates", "Candidates"], ["setup", "Assessment Setup"], ["chat", "Onboarding Chat"], ["agreements", "Agreements"]];

export default function AdminCreators() {
  const [tab, setTab] = useState("candidates");
  const [copied, setCopied] = useState(false);
  const link = `${window.location.origin}/creator`;
  const copy = async () => { try { await navigator.clipboard.writeText(link); } catch { /* clipboard blocked */ } setCopied(true); setTimeout(() => setCopied(false), 2000); };

  return (
    <>
      <div className="page-head">
        <div><h1>AI Audiobook Creators</h1><p>Candidates sign in with Google at <code>{link}</code>, chat with the hiring assistant, fill their details, clear the language and listening tests, then sign the NDA and Freelancer agreement.</p></div>
        <div className="page-head-side">
          <button className="ghost" onClick={copy} data-testid="copy-creator-link"><Copy size={14} /> {copied ? "Link copied" : "Copy creator sign-in link"}</button>
          <div className="chip-row">
            {TABS.map(([id, label]) => <button key={id} className={`chip ${tab === id ? "active" : ""}`} onClick={() => setTab(id)} data-testid={`creators-tab-${id}`}>{label}</button>)}
          </div>
        </div>
      </div>
      {tab === "candidates" && <CandidateTable />}
      {tab === "setup" && <AssessmentSetup />}
      {tab === "chat" && <OnboardingScriptEditor />}
      {tab === "agreements" && <CreatorAgreementsAdmin />}
    </>
  );
}
